// src/domains/core/dashboard/components/widgets/admin/GitStatusWidget.tsx

import { GitBranch } from "lucide-react";
import { type FC } from "react";
import { useNavigate } from "react-router-dom";

import { Text, Heading, Card, Button } from "@/components/ui";

import { useWidgetConfig } from "../../../hooks/useWidgetConfig";
import { WIDGET_IDS } from "../../../store/widgetRegistry";
import { WidgetContainer } from "../base";

/**
 * GitStatusWidget - Quick Access zu Git Management
 *
 * NOTE: Git Status Daten-Loading wird in zukünftiger Version implementiert
 *
 * @returns {JSX.Element} Git status widget component
 *
 */
export const GitStatusWidget: FC = () => {
  const { config } = useWidgetConfig(WIDGET_IDS.GIT_STATUS);
  const navigate = useNavigate();

  // NOTE: Git Status Hook wird in zukünftiger Version implementiert
  const loading = false;
  const currentBranch = "main";

  return (
    <WidgetContainer
      description="Repository overview"
      icon={<GitBranch className="w-5 h-5" />}
      loading={loading}
      size={config?.size ?? "small"}
      title="Git Status"
      widgetId={WIDGET_IDS.GIT_STATUS}
    >
      <div className="space-y-3">
        <Card padding="sm" variant="default">
          <Text className="text-xs text-gray-400 mb-1">Current Branch</Text>
          <Heading className="text-sm font-semibold text-white" level={5}>
            {currentBranch}
          </Heading>
        </Card>

        <Button
          className="w-full"
          onClick={() => {
            // Reason: navigate() returns void, but ESLint treats it as Promise
            // eslint-disable-next-line sonarjs/void-use -- Reason: navigate() returns void, not Promise
            void navigate("/git-management");
          }}
          size="sm"
          variant="outline"
        >
          Manage Git
        </Button>
      </div>
    </WidgetContainer>
  );
};
